<template>
  <div class="card text-white text-left mb-5">
    <div class="maskot">
      <img src="~@/assets/img/maskot.png" class="maskot-img">
    </div>
    <div class="card-body monaco pt-5">
      <details>
        <summary><strong>Case 1: Read file & count the lines</strong></summary>
        <p>
          <br>
          <strong>Story</strong>: <br>
          Nizam seorang pelajar Sekolah Dasar yang gemar <em>Coding</em>. Saat ini Nizam
          belajar bagaimana cara membaca dan menulis file. Kasusnya, isi file tersebut terdiri
          macam-macam daftar bahasa pemrograman. Bantulah Nizam untuk membuat progam yang
          dapat membaca banyaknya daftar bahasa pemrograman dalam file tersebut.
          <br><br>
          <strong>Ketentuan</strong>: <br>
          <ul>
            <li>Download file <em>in.txt</em> <a href="/in.txt" download>disini</a></li>
            <li>Baca file tersebut dengan program</li>
            <li>Output berupa <em>number</em> (jumlah bahasa pemrorgaman dari isi file tersebut)</li>
          </ul>
          <strong><em>output</em></strong>: <br>
          <pre>
            3
          </pre>

          <!-- <strong>Kirim Jawaban</strong>: -->
        </p>
      
        <!-- <div class="row">
          <div class="col-md-6">
            <div v-if="submited" class="alert alert-success mt-3">Jawaban kamu berhasil terkirim!</div>
            <form @submit.prevent="submitAnswer">
              <div class="form-group">
                <label for="">Email <em>(never publish)</em></label>
                <input type="email" v-model="email" placeholder="email (@smkn4-tsm.sch.id)" autofocus autocomplete="off" class="form-control" required>
              </div>
              <div class="form-group">
                <label for="">Nama Lengkap</label>
                <input type="text" v-model="nama" :disabled="email.length < 10" placeholder="nama kamu?" class="form-control" required>
              </div>
              <div class="form-group">
                <label for="">Kelas:</label>
                <select class="form-control" v-model="kelas" :disabled="nama.length < 3" required>
                  <option>&#8212; Pilih Kelas &#8212;</option>
                  <option value="X.PPLG-1">X.PPLG-1</option>
                  <option value="X.PPLG-2">X.PPLG-2</option>
                  <option value="X.PPLG-3">X.PPLG-3</option>
                  <option value="X.PPLG-4">X.PPLG-4</option>
                </select>
              </div>
              <div class="form-group">
                <label for="">Jawaban</label>
                <textarea v-model="jawaban" :disabled="kelas.length < 1" cols="30" rows="10" class="form-control" placeholder="Paste code program kamu disini..."></textarea>
              </div>
              <span v-if="!sending"><button :disabled="jawaban.length < 10" class="btn btn-green btn-block text-white">Kirim</button></span>
              <span v-else>sedang mengirim</span>
              <div v-if="submited" class="alert alert-success mt-3">Jawaban kamu berhasil terkirim!</div>
            </form>
          </div>
        </div> -->
      </details>
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      nama: '',
      kelas: '',
      jawaban: '',
      submited: false,
      sending: false,
    }
  },

  methods: {
    async submitAnswer() {
      this.sending = true
      let { data, error } = await this.$supabase
      .from('score2023')
      .insert([
        {
          email: this.email,
          nama: this.nama,
          kelas: this.kelas,
          jawaban: this.jawaban,
          case: 1
        }
      ])
      
      this.sending = false
      if (data) {
        this.submited = true
        this.email = ''
        this.nama = ''
        this.kelas = ''
        this.jawaban = ''
      }
    }
  }
};
</script>

<style scoped>
details {
  margin: 20px 0 20px 0;
}
pre {
  padding: 20px;
  padding-left: 0;
  padding-right: 0;
  color: #fff;
  background-color: #0b0b0b;
  border-top: 3px solid #fff;
  border-bottom: 3px solid #fff;
}
</style>
